/**
 * 项目管理
 */
const ProjectDescRouter = {
  path: '/project',
  component: () => import('@/views/layout'),
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: 'manage/add',
      name: 'long_add_project',
      hidden: true,
      component: () => import('@/views/all_project/CB/edit_project'),
      meta: {
        title: '新增项目'
      }
    },
    // 长保编辑项目
    {
      path: 'manage/edit1/:id',
      name: 'long_edit_project',
      hidden: true,
      component: () => import('@/views/all_project/CB/edit_project'),
      meta: {
        title: '编辑项目'
      }
    },
    // 特保编辑项目
    {
      path: 'manage/edit2/:id',
      name: 'spec_edit_project',
      hidden: true,
      component: () => import('@/views/all_project/LB/edit_project'),
      meta: {
        title: '编辑项目'
      }
    },
    // 联网编辑项目
    {
      path: 'manage/edit3/:id',
      name: 'net_edit_project',
      hidden: true,
      component: () => import('@/views/all_project/LW/edit_project'),
      meta: {
        title: '编辑项目'
      }
    },
    // 咨询编辑项目
    {
      path: 'manage/edit4/:id',
      name: 'cons_edit_project',
      hidden: true,
      component: () => import('@/views/all_project/ZX/edit_project'),
      meta: {
        title: '编辑项目'
      }
    },

    // 风险评估编辑项目
    {
      path: 'manage/edit5/:id',
      name: 'fp_edit_project',
      hidden: true,
      component: () => import('@/views/all_project/FP/edit_project'),
      meta: {
        title: '编辑项目'
      }
    },

    // 课题编辑项目
    {
      path: 'manage/edit6/:id',
      name: 'kt_edit_project',
      hidden: true,
      component: () => import('@/views/all_project/KT/edit_project'),
      meta: {
        title: '编辑项目'
      }
    },

    // 项目确认
    {
      path: 'manage/execute1/:id',
      name: 'cb_execute',
      hidden: true,
      component: () => import('@/views/all_project/CB/execute_project'),
      meta: {
        title: '项目确认'
      }
    },
    {
      path: 'manage/execute2/:id',
      name: 'lb_execute',
      hidden: true,
      component: () => import('@/views/all_project/LB/execute_project'),
      meta: {
        title: '项目确认'
      }
    },
    {
      path: 'manage/execute3/:id',
      name: 'lw_execute',
      hidden: true,
      component: () => import('@/views/all_project/LW/execute_project'),
      meta: {
        title: '项目确认'
      }
    },
    {
      path: 'manage/execute4/:id',
      name: 'zx_execute',
      hidden: true,
      component: () => import('@/views/all_project/ZX/execute_project'),
      meta: {
        title: '项目确认'
      }
    },
    {
      path: 'manage/execute5/:id',
      name: 'fp_execute',
      hidden: true,
      component: () => import('@/views/all_project/FP/execute_project'),
      meta: {
        title: '项目确认'
      }
    },
    {
      path: 'manage/execute6/:id',
      name: 'kt_execute',
      hidden: true,
      component: () => import('@/views/all_project/KT/execute_project'),
      meta: {
        title: '项目确认'
      }
    },

    {
      path: 'manage/detail/:id',
      name: 'long_project_details',
      hidden: true,
      component: () => import('@/views/all_project/CB/project_details'),
      meta: {
        title: '项目详情'
      }
    },

    // 执勤签到
    {
      path: 'patrol/checkDuty/:id',
      name: 'check_duty',
      hidden: true,
      component: () => import('@/views/patrol/check_duty'),
      meta: {
        title: '执勤签到'
      }
    },

    // 表扬投诉详情
    {
      path: 'praise/:name/:id',
      name: 'isPraiseInfo',
      hidden: true,
      component: () => import('@/views/isPraise/components/isPraiseInfo'),
      meta: {
        title: '详情'
      }
    },
    // 满意度评分 详情
    {
	  path: 'praise/:id',
	  name: 'satisfyInfo',
	  hidden: true,
	  component: () => import('@/views/isPraise/components/satisfyInfo'),
	  meta: {
	    title: '详情'
	  }
    },

    // 变更记录
    {
      path: 'manage/change/:name/:id',
      name: 'project_change',
      hidden: true,
      component: () => import('@/views/all_project/components/project_change.vue'),
      meta: {
        title: '详情'
      }
    },
    {
      path: 'manage/personnel/list',
      name: 'project_personnel_list',
      hidden: true,
      component: () => import('@/views/all_project/components/project_personnel_list'),
      meta: {
        title: '项目人员'
      }
    },
    {
      path: 'manage/personnel/:id',
      name: 'project_personnel_desc',
      hidden: true,
      component: () => import('@/views/all_project/components/project_personnel_desc'),
      meta: {
        title: '项目人员详情'
      }
    }
  ]
}

export default ProjectDescRouter
